var _rect, _g, _g2, _g3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 40.96,
    fill: "#010830"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_249_9457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.122 114.158C141.068 95.5082 163.938 86.4977 176.619 100.173L315.66 250.113C323.351 258.407 322.862 271.365 314.569 279.056L176.337 407.239C163.25 419.375 141.984 410.129 141.932 392.282L141.122 114.158Z",
    fill: "#FF9574"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_249_9457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.856 110.127C237.802 91.4777 260.672 82.4672 273.353 96.142L412.394 246.083C420.085 254.376 419.596 267.334 411.303 275.025L273.071 403.209C259.984 415.344 238.717 406.099 238.665 388.251L237.856 110.127Z",
    fill: "#BEE2B5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_249_9457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.731 185.928C100.64 167.259 123.534 158.213 136.228 171.903L204.546 245.576C212.237 253.87 211.748 266.828 203.454 274.518L135.803 337.252C122.731 349.374 101.485 340.163 101.398 322.335L100.731 185.928Z",
    fill: "#FFCD43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331.637 237.091C328.165 237.091 324.836 238.47 322.381 240.925C319.926 243.38 318.546 246.71 318.546 250.182C318.546 253.654 319.926 256.984 322.381 259.439C324.836 261.894 328.165 263.273 331.637 263.273C335.109 263.273 338.439 261.894 340.894 259.439C343.349 256.984 344.728 253.654 344.728 250.182C344.728 246.71 343.349 243.38 340.894 240.925C338.439 238.47 335.109 237.091 331.637 237.091ZM331.637 272C325.851 272 320.301 269.701 316.209 265.61C312.118 261.518 309.819 255.968 309.819 250.182C309.819 244.395 312.118 238.846 316.209 234.754C320.301 230.662 325.851 228.364 331.637 228.364C337.424 228.364 342.973 230.662 347.065 234.754C351.157 238.846 353.455 244.395 353.455 250.182C353.455 255.968 351.157 261.518 347.065 265.61C342.973 269.701 337.424 272 331.637 272ZM331.637 217.455C309.819 217.455 291.186 231.026 283.637 250.182C291.186 269.338 309.819 282.909 331.637 282.909C353.455 282.909 372.088 269.338 379.637 250.182C372.088 231.026 353.455 217.455 331.637 217.455Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_249_9457",
    x: 132.93,
    y: 93.5763,
    width: 196.385,
    height: 335.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.192
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.096
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_9457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_9457",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_249_9457",
    x: 229.664,
    y: 89.5458,
    width: 196.385,
    height: 335.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.192
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.096
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_9457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_9457",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_249_9457",
    x: 92.539,
    y: 165.306,
    width: 125.662,
    height: 193.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.192
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.096
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_9457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_9457",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.52784edfd34cc56ac57fa21aa9f9934f.svg";
export { ForwardRef as ReactComponent };